import { authType } from '../utils/auth'
import { Route, Switch } from 'react-router-dom'

import Auth from '../components/Auth'
import PrivateRoute from './PrivateRoute'
import React, { Component } from 'react'

import {
  Overview,
  ProductMap,
  NotFound,
  Home,
  ControlledProducts,
  Inventory,
  IncompatibilityAnalysis,
  Login,
  RecoverPassword,
  LoginError,
  CabinetProducts,
  AreaFds,
  ProductFds,
  ControllerFispq,
  // Legislation
} from '../containers'


export default class Routes extends Component {
  render() {
    return (
      <Switch>
        {authType('adfs') && (<Route exact path="/login/:token" component={router => <Auth router={router} />} />)}

        {authType('adfs') && (<Route exact path="/erro-login" component={router => <LoginError router={router} />} />)}

        {authType('local') && (<Route exact path="/recuperar-senha" component={router => <RecoverPassword router={router} />} />)}

        {authType('local') && (<Route exact path="/entrar" component={router => <Login router={router} />} />)}

        <Route exact path="/sair" component={router => <Auth router={router} />} />

        <Route exact path="/armarios/:id" component={router => <CabinetProducts router={router} />} />

        <Route exact path="/fds/area/:token" component={router => <AreaFds router={router} />} />

        <Route exact path="/fds/produto/:token" component={router => <ProductFds router={router} />} />

        <PrivateRoute exact path="/" component={router => <Home router={router} />} />

        <PrivateRoute
          exact
          path="/mapa-de-produtos/mapa-de-quimicos"
          component={router => {
            return <ProductMap.ChemicalMap router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/mapa-de-produtos/controle-de-certificados"
          component={router => {
            return <ProductMap.CertificateControl router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/analise-de-incompatibilidade"
          component={router => {
            return <IncompatibilityAnalysis router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/produtos-controlados/licencas"
          component={router => {
            return <ControlledProducts.License router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/produtos-controlados/relacao-de-produtos-controlados"
          component={router => {
            return <ControlledProducts.List router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/produtos-controlados/relatorios"
          component={router => {
            return <ControlledProducts.ControlledProductReport router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/produtos-controlados/mapas-de-consumo"
          component={router => {
            return <ControlledProducts.ConsumptionMap router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/licencas-terceiros"
          component={router => {
            return <ControlledProducts.License router={router} thirdParty />
          }}
        />

        <PrivateRoute
          exact
          path="/panorama-geral-de-produtos"
          component={router => {
            return <Overview router={router} />;
          }}
        />

        <PrivateRoute
          exact
          path="/estoque-produtos-quimicos/estoque"
          component={router => {
            return <Inventory.Stock router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/estoque-produtos-quimicos/historico"
          component={router => {
            return <Inventory.Historic router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/estoque-produtos-quimicos/historico-produtos-estoque"
          component={router => {
            return <Inventory.HistoricReport router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/estoque-produtos-quimicos/relatorio"
          component={router => {
            return <Inventory.Report router={router} />
          }}
        />

        <PrivateRoute
          exact
          path="/controle-de-fispq"
          component={router => {
            return <ControllerFispq router={router} />
          }}
        />

        {/* <PrivateRoute
          exact
          path="/legislacao"
          component={router => {
            return <Legislation router={router} />
          }}
        /> */}

        {/* Not Found Route */}
        <PrivateRoute
          component={router => {
            return <NotFound router={router} />
          }}
        />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/index.js